// src/pages/VerifyEmailComplete.js
// Custom landing page for the link in the verification email — replaces
// Firebase's default bare "Your email has been verified" page. Firebase
// appends mode/oobCode to the URL passed as actionCodeSettings.url in
// sendEmailVerification (see AuthContext.js and VerifyEmail.js).
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from '../firebase/config';

export default function VerifyEmailComplete() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const navigate = useNavigate();

  useEffect(() => {
    const oobCode = searchParams.get('oobCode');
    if (!oobCode) {
      setStatus('error');
      return;
    }
    applyActionCode(auth, oobCode)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchParams]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 24 }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }} className="fade-up">
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: 24 }}>⏳</div>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', marginBottom: 12 }}>
              Verifying your email...
            </h1>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: 24 }}>✅</div>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', marginBottom: 12 }}>
              Email verified
            </h1>
            <p style={{ color: 'var(--ink-muted)', marginBottom: 32, lineHeight: 1.7 }}>
              Your account is ready. Sign in to get started.
            </p>
            <button className="btn btn-primary" onClick={() => navigate('/login')}>
              Continue to sign in →
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: 24 }}>⚠️</div>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', marginBottom: 12 }}>
              This link didn't work
            </h1>
            <p style={{ color: 'var(--ink-muted)', marginBottom: 32, lineHeight: 1.7 }}>
              It may have expired or already been used. Sign in and we'll send you a fresh one if needed.
            </p>
            <button className="btn btn-primary" onClick={() => navigate('/login')}>
              Go to sign in →
            </button>
          </>
        )}
      </div>
    </div>
  );
}
